import {NEXT_MENU} from '../utils/query_utils';

export const queryBuilderState = {
    inputRef: null,
    menu: null,
    attribute: null, // DatasetAttribute - src/models/dataset/dataset_attribute
    searchQuery: '',

    getInputPosition() {
        if (!this.inputRef) {
            return {top: 0, left: 0, bottom: 0, right: 0};
        }
        const top = this.inputRef.offsetTop + this.inputRef.offsetParent.offsetTop + this.inputRef.offsetParent.offsetParent.offsetTop + this.inputRef.offsetParent.offsetParent.offsetParent.offsetTop;
        const left = this.inputRef.offsetLeft + this.inputRef.offsetParent.offsetLeft + this.inputRef.offsetParent.offsetParent.offsetLeft + this.inputRef.offsetParent.offsetParent.offsetParent.offsetLeft;
        const bottom = top + this.inputRef.offsetHeight;
        const right = left + this.inputRef.offsetWidth;
        return {top, left, bottom, right};
    },

    getNextMenu(currentMenu = this.menu) {
        if (this.attribute) {
            return NEXT_MENU[this.attribute.type][currentMenu];
        }
        return null;
    },
};

export function resetState() {
    Object.assign(queryBuilderState, {
        inputRef: null,
        menu: null,
        attribute: null,
        searchQuery: '',
    });
}
